module.exports = {
          srcSet: __webpack_public_path__ + "47dd283d0364558e958138e76c61d8d5-84.png"+" 84w",
          images:[ {path: __webpack_public_path__ + "47dd283d0364558e958138e76c61d8d5-84.png",width: 84,height: 84}],
          src: __webpack_public_path__ + "47dd283d0364558e958138e76c61d8d5-84.png",
          toString:function(){return __webpack_public_path__ + "47dd283d0364558e958138e76c61d8d5-84.png"},
          
          width: 84,
          height: 84
        }